export default "__VITE_ASSET__fae5f0cd__"